/* eslint-disable no-console */

const nr = {
  noticeError(err) {
    console.error(err);
  },
  setErrorHandler(handler) {
    console.info(`Handled error ${handler()}`);
  },
};

const newRelic = window.newrelic || nr;
export default newRelic;
